import styled from 'styled-components';

const ASPECT_RATIO = 0.462; // iPhone 13 844 × 390 (19.5:9)
// const MOBILE_HEIGHT = 844;
// const MOBILE_WIDTH = Math.round(ASPECT_RATIO * MOBILE_HEIGHT);

const MOBILE_WIDTH = 365;
const MOBILE_HEIGHT = Math.round(MOBILE_WIDTH / ASPECT_RATIO);

interface ApplicationsPreviewResponsiveLayoutProps {
  device: DeviceTypes;
}

export const ApplicationsPreviewResponsiveLayout = styled.div<ApplicationsPreviewResponsiveLayoutProps>`
  position: relative;
  margin: auto;
  width: ${(props) => (props.device === `phone` ? `${MOBILE_WIDTH}px` : `100%`)};
  height: ${(props) => (props.device === `phone` ? `${MOBILE_HEIGHT}px` : `100%`)};
  border-radius: 2px;
  background-color: white;
  scroll: auto;
`;

export const deviceTypes = [`phone`, `desktop`] as const;

export type DeviceTypes = (typeof deviceTypes)[number];
